module.exports = __webpack_public_path__ + "img/ch08_06_草莓泡芙.d9a2f9ee.jpg";